<template>
  <aside class="side-nav pr-3 pb-3" :class="wideOpen">
    <fieldset>
      <legend class="mb-0">
        {{ $t("hellovue.sidenav.change_view") }}
      </legend>
      <div
        @click.prevent="setView($t('hellovue.view.street_view')), zoom(true, 1), setStreetView($t('hellovue.view.street_view'))"
        class="side-nav-button py-2 mb-2" :class="{ active: streetViewStatus === $t('hellovue.view.street_view') }">
        <label class="mb-0" for="btn-facade"><span>
            {{ $t("hellovue.sidenav.street_view") }}
          </span></label>
        <input type="radio" name="pov" id="btn-facade" class="radio-hidden" />
      </div>
      <div
        @click.prevent="setView($t('hellovue.view.cross_section_view'), setStreetView($t('hellovue.view.cross_section_view')))"
        class="side-nav-button py-2 mb-2"
        :class="{ active: streetViewStatus === $t('hellovue.view.cross_section_view') }">
        <label class="mb-0" for="btn-cutimage"><span>{{ $t("hellovue.sidenav.cut_view") }}</span></label>
        <input type="radio" name="pov" id="btn-cutimage" class="radio-hidden" />
      </div>
    </fieldset>
    <transition mode="out-in">
      <ul v-if="streetViewStatus === $t('hellovue.view.cross_section_view')" class="list-of-components">
        <side-navigation-accordion v-for="type in getUniqueDataTypes" :key="type" :target="type" />
      </ul>
    </transition>
  </aside>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SideNavigationAccordion from "src/components/partials/SideNavigationAccordion.vue";
import { dragAndZoom } from "src/mixins/dragAndZoom.js";

export default {
  name: "SideNavigation",
  components: { SideNavigationAccordion },
  mixins: [dragAndZoom],
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getUniqueDataTypes",
      "getDataByType",
      "sideNavigationWideStatus",
      "streetViewStatus",
    ]),
    wideOpen: function () {
      if (this.sideNavigationWideStatus && window.innerWidth > 1024) {
        return "side-nav-wide-open";
      } else {
        return;
      }
    },
  },
  methods: {
    ...mapActions(["setStreetView"]),
    setView(view_type) {

      // Go to specific view via router
      this.$router.push({
        name: "componentpage_view",
        params: {
          componentName: this.$router.currentRoute.params.componentName,
          view: view_type,
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.side-nav {
  width: 100%;
  transition: all 0.3s;

  @media (max-width: 1024px) {
    overflow-y: hidden;
  }

  @media (min-width: 1024px) {
    min-width: 20%;
    width: 25%;
  }

  &.side-nav-wide-open {
    width: 35%;
  }
}

.radio-hidden {
  visibility: none;
  opacity: 0;
}

.side-nav-button {
  width: 100%;
  background: none;
  border: 1px solid #002f6c;
  text-align: center;
}

.active {
  background-color: #002f6c !important;
  color: white !important;

  :focus {
    box-shadow: none !important;
  }
}

fieldset {
  :focus-within {
    outline: 3px solid #f18700 !important;
  }
}

.list-of-components {
  border-left: 1px solid black;
  margin-left: 20px;
  list-style: none;
}

// transition
.v-leave {
  opacity: 1;
}

.v-leave-active {
  transition: opacity 0.3s;
}

.v-leave-to {
  opacity: 0;
}

.v-enter {
  opacity: 0;
}

.v-enter-active {
  transition: opacity 0.3s;
}

.v-enter-to {
  opacity: 1;
}
</style>